import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useFetchContestDetails from '../hooks/useFetchContestDetails';
import ContestDetails from '../details/ContestDetails';
import ParticipantsTablePokerRegistering from '../tables/ParticipantsTablePokerRegistering';
import ParticipantsTableGolfRegistering from '../tables/ParticipantsTableGolfRegistering';
import ParticipantsTableChessRegistering from '../tables/ParticipantsTableChessRegistering';
import ParticipantsTableEsportsRegistering from '../tables/ParticipantsTableEsportsRegistering';
import BackButton from '../components/general/BackButton';
import '../components/ContestInfo.css';
import { fetchSelectedContestDetails } from '../../../utils/api';
import io from 'socket.io-client';
import { toast } from 'react-hot-toast';

const SOCKET_URL = process.env.NODE_ENV === 'production'
  ? 'https://onetimefantasy.com'
  : 'http://localhost:5000';

const ContestInfoRegistering = () => {
  const params = useParams();
  const navigate = useNavigate();
  // console.log('[ContestInfoRegistering] Component rendered. Params:', params);

  const { id } = params;
  // console.log('[ContestInfoRegistering] Extracted ID:', id);

  const { contest: contestDetails, loading, error } = useFetchContestDetails(id);

  useEffect(() => {
    if (!id) return;

    const socket = io(SOCKET_URL);

    socket.emit('joinDraftRoom', { contestId: id });

    socket.on('draftStarting', () => {
      console.log('Draft is starting! Redirecting...');
      toast.success('Draft is starting! Redirecting to draft room...', {
        duration: 2000
      });
      setTimeout(() => {
        navigate(`/draft/${id}`);
      }, 2000);
    });

    return () => {
      socket.disconnect();
    };
  }, [id, navigate]);

  // NEW: Effect to handle redirect if draft is already in progress on load
  useEffect(() => {
    if (contestDetails?.status === 'Drafting') {
      console.log('Contest is already drafting, redirecting...');
      navigate(`/draft/${id}`);
    }
  }, [contestDetails, id, navigate]);

  if (loading) {
    return (
      <div className="contest-loading-info">
        Loading Contest Information...
      </div>
    );
  }

  if (error) {
    return <div className="contest-loading-info">Error: {error}</div>;
  }

  if (!contestDetails) {
    return (
      <div className="contest-loading-info">
        Contest details not found or ID was invalid.
      </div>
    );
  }

  let ParticipantsTableComponent;
  switch (contestDetails.sport) {
    case 'Golf':
      ParticipantsTableComponent = ParticipantsTableGolfRegistering;
      break;
    case 'Chess':
      ParticipantsTableComponent = ParticipantsTableChessRegistering;
      break;
    case 'Esports':
      ParticipantsTableComponent = ParticipantsTableEsportsRegistering;
      break;
    case 'Poker':
    default:
      ParticipantsTableComponent = ParticipantsTablePokerRegistering;
      break;
  }

  return (
    <div className="contest-details-container">
      <BackButton to="/contests/registering">
        ◄ Back to Registering Contests
      </BackButton>
      {contestDetails && <ContestDetails contest={contestDetails} showEnterButton={true} />}
      <ParticipantsTableComponent contest={contestDetails} />
    </div>
  );
};

export default ContestInfoRegistering;
